<section class="curation-send-action">
  <label class="curation-send-action-label">Add comments</label>
  <label class="curation-send-action-label-optional">(optional)</label>
</section>
<textarea id="curationactiontextarea"
          [(ngModel)]="message"
          rows="7"
          class="curation-send-action-text">
 </textarea>
